import { zustandImmerMiddleware } from '@sketchnote/shared-components';
import { useWorkspaceService } from 'src/api/services/workspaces/workspace';
import { FileType } from 'src/features/files/types/file';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export interface WorkspaceState {
  workspace: any;
  workspaceAuthorisation: 'authorised' | 'unAuthorised' | 'unAvailable';

  files: FileType[];
  isLoading?: boolean;
  favorites: FileType[];
  collapseFavorites: boolean;
  collapseFiles: boolean;
  actions: {
    fetchWorkspaceData: (id: string) => void;
    fetchWorkspace: (id: string) => void;
    onCreateNew: ({ id, value }: { id: string; value: string }) => Promise<any> | void;
    onUpdateWorkspace: ({
      id,
      name,
      description,
      coverImage,
      isCoverFit,
      icon,
    }: {
      id: string;
      name?: string;
      description?: string;
      coverImage?: string;
      isCoverFit?: boolean;
      // icon?: any;
      icon?: {
        id?: any;
        type?: string;
      };
    }) => Promise<any> | void;
    onInviteUsers: ({
      id,
      members,
      emails,
    }: {
      id: string;
      members: string[];
      emails: string[];
    }) => Promise<any> | void;
    pinFile?: (file: any, pin: boolean) => void;
  };
}

const getInitialValue = () => ({
  workspace: {},
  files: [],
  favorites: [],
  collapseFavorites: false,
  collapseFiles: false,
  workspaceAuthorisation: 'authorised' as WorkspaceState['workspaceAuthorisation'],
});

export const useWorkspaceStore = create<
  WorkspaceState,
  [['zustand/devtools', WorkspaceState], ['zustand/immer', WorkspaceState]]
>(
  devtools(
    zustandImmerMiddleware((set) => ({
      actions: {
        fetchWorkspace: async (id) => {
          set((s) => {
            s.isLoading = true;
          });
          const responseWorkspaceDetails = await useWorkspaceService().fetchWorkspacebyId({ id });

          if (responseWorkspaceDetails?.data) {
            if (responseWorkspaceDetails?.data === 7002) {
              set((s) => {
                s.workspace = {};
                s.isLoading = false;
                s.workspaceAuthorisation = 'unAuthorised';
              });
            } else if (responseWorkspaceDetails?.data === 7001) {
              set((s) => {
                s.workspace = {};
                s.isLoading = false;
                s.workspaceAuthorisation = 'unAvailable';
              });
            } else {
              set((s) => {
                s.workspace = responseWorkspaceDetails.data;
                s.isLoading = false;
                s.workspaceAuthorisation = 'authorised';
              });
            }
          }
        },
        fetchWorkspaceData: async (id) => {
          const responseWorkspaceFiles = await useWorkspaceService().fetchWorkspaceFiles({ id });

          if (responseWorkspaceFiles) {
            set((s) => {
              s.files = responseWorkspaceFiles;
            });
          }

          const responseWorkspaceFavoriteFiles =
            await useWorkspaceService().fetchWorkspaceFavorites({
              id,
            });

          if (responseWorkspaceFavoriteFiles) {
            set((s) => {
              s.favorites = responseWorkspaceFavoriteFiles;
            });
          }
        },

        onUpdateWorkspace: async ({ id, name, description, coverImage, icon, isCoverFit }) => {
          const response = await useWorkspaceService().onUpdateWorkspace({
            id,
            name,
            description,
            coverImage,
            icon,
            isCoverFit,
          });
          if (response?.data) {
            return response;
          }
        },

        onCreateNew: async ({ id, value }) => {
          const response = await useWorkspaceService().onCreateNew({ id, value });
          return response;
        },
        onInviteUsers: async ({ id, members, emails }) => {
          const response = await useWorkspaceService().onInviteUsers({ id, members, emails });
          return response;
        },

        pinFile: (file, pin) => {
          const fileToPin = file;
          fileToPin && (fileToPin.pinned = pin);
          set((s) => {
            const file = s.files.find((f) => f.id === fileToPin._id);
            if (file) {
              file.pin = pin;
            }
          });
        },
      },

      ...getInitialValue(),
    }))
  )
);
